<div class="bg-gray-100 min-h-screen">
  <header class="bg-white shadow-sm border-b">
    <div class="container mx-auto px-4 py-3 text-center">
      <h1 class="text-xl font-bold prompt-black">ลงทะเบียน</h1>
    </div>
  </header>
  <main class="container mx-auto py-0 justify-center">
    <div class="p-5">
      <label class="block text-gray-700 text-sm mb-2 font-bold">
        เบอร์โทร
      </label>
      <label
        class="block text-gray-700 mb-2 font-normal text-4xl"
        [style.color]="'rgb(168,168,168)'"
      >
        {{ phone || "ไม่พบหมายเลข" }}
      </label>
      <label class="block text-gray-700 text-sm font-bold mb-2 mt-5" [style]="">
        รหัสยืนยันมือถือ(OTP)
      </label>
      <div class="flex flex-col space-y-16">
        <div class="flex space-x-2">
          <input
            *ngFor="let item of array; let i = index"
            #otpInput
            type="tel"
            maxlength="1"
            inputmode="numeric"
            class="w-full h-16 text-center text-3xl border border-gray-300 rounded"
            [attr.autocomplete]="i === 0 ? 'one-time-code' : null"
            [value]="otpValues[i]"
            (input)="onInput($event, i)"
            (keydown)="onKeyDown($event, i)"
            (paste)="i === 0 && onPaste($event)"
          />
        </div>
      </div>
      <!--  -->
      <label
        *ngIf="refNo"
        class="block text-gray-400 text-gray-400 text-sm mb-0 font-normal text-center mt-4"
      >
        (Ref No. : {{ refNo || "-" }})
      </label>
      <div class="mt-2">
        <div class="flex flex-col space-y-5">
          <label
            class="flex justify-center items-center text-sm mt-5 cursor-pointer"
            [ngClass]="{
              'cursor-not-allowed text-gray-400': !canResend || loading,
              'hover:underline  text-green-600': canResend && !loading
            }"
            (click)="reSendRegister()"
          >
            <ng-container *ngIf="loading">
              <span class="animate-spin mr-2">⏳</span> กำลังส่ง OTP...
            </ng-container>

            <ng-container *ngIf="!loading && !canResend">
              ส่งรหัสยืนยันอีกครั้ง (รอ {{ countdown }} วิ)
            </ng-container>

            <ng-container *ngIf="!loading && canResend">
              ส่งรหัสยืนยันอีกครั้ง
            </ng-container>
          </label>

          <!-- <button
            [style.color]="'white'"
            [disabled]="loading"
            (click)="sendRegister()"
            [ngClass]="{
              'flex flex-row items-center justify-center text-center w-full border rounded-xl outline-none py-2.5 text-sm shadow-sm': true,
              'bg-green-500 !text-white border-none': !loading,
              'bg-gray-400 !text-white cursor-not-allowed': loading
            }"
          >
            <ng-container *ngIf="loading; else normal">
              <span class="animate-spin mr-2">⏳</span> กำลังส่ง OTP...
            </ng-container>
            <ng-template #normal> ส่งรหัสยืนยันอีกครั้ง </ng-template>
          </button> -->
        </div>
        <div class="mt-6">
          <button
            [disabled]="!isButton || error !== ''"
            (click)="handleClick()"
            [ngClass]="{
              'w-full py-2 px-4 font-bold text-white rounded-xl transition-all duration-300': true,
              'bg-green-500 hover:bg-green-600 cursor-pointer':
                isButton && error === '',
              'bg-gray-400 cursor-not-allowed': !isButton || error !== ''
            }"
          >
            <ng-container *ngIf="isConfiorm; else normal">
              <span class="animate-spin mr-2">⏳</span> กำลังยืนยัน OTP...
            </ng-container>
            <ng-template #normal> ยืนยันหมายเลขโทรศัพท์ </ng-template>
          </button>
        </div>
        <div
          class="flex flex-row items-center justify-center text-center text-sm font-medium space-x-1 text-gray-500"
        >
          <a
            class="flex flex-row items-center text-green-500 mt-4 underline"
            (click)="backClick()"
            target="_blank"
            rel="noopener noreferrer"
          >
            กลับหน้าหลัก
          </a>
        </div>
      </div>
    </div>
  </main>
</div>
